<template>
  <div class="photo-Particular">
    <!--  -->
    <!-- 相册详情 -->
    <div class="photo-Particular-top">
      <span>
        <img src="../../assets/img/home-icon.png" alt="" class="home-icon-img">
        <router-link :to="{ name: 'home' }">首页</router-link>
      </span>&nbsp;/&nbsp;
      <span>
        素材管理
      </span>&nbsp;/&nbsp;
      <span>
        <router-link :to="{ name: 'material/photo' }">相册管理</router-link>
      </span>&nbsp;/&nbsp;
      <span>{{ pname }}</span>
      <el-button icon="el-icon-back" class="retrunbtn" type="text" @click="urlback" v-if="albumid > 0">返回</el-button>
    </div>
    <div class="photo-Particular-content" v-loading="loading">
      <div class="photo-Particular-content-top">
        <div style="display:flex;">
          <el-upload class="photo-Particular-upload" action="/api/file/upload" :headers="headers" :show-file-list="false"
            :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :on-error="uploadError" multiple
            accept=".mp4,.mov,.jpg,.png">
            <el-button class="photo-Particular-upload-btn" :loading="uploading" icon="el-icon-upload">
              批量上传
            </el-button>
          </el-upload>
        </div>
        <div>
          <span class="type-title">类型：</span>
          <el-select v-model="typeValue" placeholder="请选择" class="type-select" @change="changetype">
            <el-option v-for="item in typeOpt" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <span class="type-title">全选：</span><el-checkbox @change="checkall" v-model="checked"></el-checkbox>
          <el-button class="photo-Particular-del" @click="delHandle">删除</el-button>
        </div>
      </div>
      <div class="photo-Particular-botton material-list">
        <div class="material">
          <el-checkbox-group v-model="checked_ids" class="material-group">
            <div class="material-item activestyle" v-for="item in tableData" :key="item.file_id">
              <div class="material-checked">
                <el-checkbox :label="item.file_id" :key="item.file_id"></el-checkbox>
              </div>
              <div class="material-item-video" v-if="item.type == 'video'">
                <video :src="item.url" controls controlslist="nodownload nofullscreen noremoteplayback noplaybackrate"
                  disablePictureInPicture style="object-fit: fill">
                </video>
              </div>
              <div class="material-item-img" v-else-if="item.type == 'image'">
                <img :src="resize(item.url)" alt="">
                <div class="material-item-img-icon">
                  <img src="../../assets/img/img-icon.png" alt="">
                </div>
              </div>
              <span class="material-item-title">{{ item.name }}</span>
              <span class="material-item-title-time">{{ item.create_time }} </span>
              <span v-if="item.type == 'image'" class="switch-box">
                <el-switch size="mini" class="switch" inactive-text="提亮：" v-model="item.brighten"
                  @change="Brighten(item.file_id)">
                </el-switch>
                <!-- &nbsp;&nbsp;
                <el-switch size="mini" class="switch" inactive-text="背景：" v-model="item.is_bgimg"
                  @change="SetBgImg(item.file_id)">
                </el-switch> -->
              </span>
            </div>
          </el-checkbox-group>
        </div>
      </div>
      <div class="foot-page item-page">
        <el-pagination @current-change="handleCurrentChange" :current-page="current" :page-size="pageSize"
          layout="total, prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { resize } from '../../assets/js/common';
export default {
  name: 'photoParticular',
  data() {
    return {
      // 类型
      typeValue: '',
      typeOpt: [
        {
          value: '',
          label: '全部',
        },
        {
          value: 'video',
          label: '视频',
        },
        {
          value: 'image',
          label: '图片',
        }],
      panme: '',
      pid: 0,
      albumid: 0,
      headers: {},
      loading: false,
      tableData: [],
      // 选中
      checked: false,
      checked_ids: [],
      // 分页
      current: 1,
      pageSize: 12,
      total: 0,
      //上传
      uploading: false,
      up_num: 0,
      up_num2: 0,
    }
  },
  created() {
    var query = this.$route.query;
    this.pname = query.name;
    this.albumid = query.albumid;
    this.headers = { Authorization: 'Bearer ' + localStorage.getItem('ai-token') };
    this.query();

    // this.$get('/product/options?type=0', { init: '未指定', album_id: this.albumid }).then(res => {
    //   this.ai_products = res.data;
    //   if (this.ai_products.length > 1) { this.ai_form.product_id = this.ai_products[1].value }
    // })
  },
  watch: {
    up_num(n) {
      if (n != this.up_num2) { this.uploading = true; }
    },
    up_num2(n) {
      if (n == this.up_num) { this.uploading = false; }
    }
  },
  methods: {
    resize(url) {
      return resize(url)
    },
    // 文件上传
    beforeAvatarUpload(file) {
      let maxsize = 1024 * 1024 * 512;
      if (file.size > maxsize) {
        this.$message.error("文件太大超过了500M");
        return false;
      }
      // this.uploading = true;
      this.up_num += 1;
    },
    handleAvatarSuccess(res, file) {
      if (res.code == 200) {
        this.$post('/album/file_link_album', {
          files: [res.data.file_id],
          album_id: this.albumid
        }).then(res => {
          this.$message.closeAll();
          if (res.code == 200) {
            this.$message.success(file.name + " 上传完成");
            this.query();
          } else {
            this.$message.error(file.name + res.msg);
          }
        })
      } else {
        this.$message.error(file.name + res.msg);
      }

      this.up_num2 += 1;
    },
    uploadError(error, file) {
      this.$message.closeAll();
      this.$message.error(file.name + " 上传失败");
      this.up_num2 += 1;
    },
    //查询
    query() {
      this.checked = false;
      this.loading = true;
      this.checked_ids = [];
      this.$get('/album/detail', {
        album_id: this.albumid,
        type: this.typeValue,
        page: this.current,
        size: this.pageSize,
      }).then(res => {
        this.tableData = res.data.list;
        this.total = res.data.count;
        this.loading = false;
      })
    },
    handleCurrentChange(val) {
      this.current = val;
      this.query();
    },
    changetype(val) {
      this.query()
    },
    //删除
    delHandle() {
      if (this.checked_ids.length == 0) {
        this.$message.warning("请先选择一个文件");
        return;
      }

      this.$confirm('即将删除文件，是否继续？', '提示', { type: 'warning' }).then(res => {
        this.$post('/album/album_file_del', { ids: this.checked_ids }).then(res => {
          if (res.code == 200) {
            this.$message.success("删除完成");
            this.query();
          }
        })
      })
    },
    //路由
    urlto(router, params) {
      let url = router + "?" + new URLSearchParams(params).toString();
      this.$router.push(url);
    },
    urlback() {
      this.$router.go(-1);
    },
    //全选
    checkall(v) {
      if (v) {
        this.checked_ids = this.$linq.from(this.tableData).select(s => s.file_id).toArray();
      } else {
        this.checked_ids = [];
      }
    },
    Brighten(id) {
      this.$get('/file/image_brighten', { id: id }).then(res => {
        this.$message.success("设置完成")
        this.query();
      })
    },
    SetBgImg(id) {
      this.$get('/file/image_setbg', { id: id }).then(res => {
        if (res.code == 200) {
          this.$message.success("设置完成");
        } else {
          this.$message.error(res.msg);
        }
        this.query();
      })
    },
  },
}
</script>
<style scoped>
.photo-Particular-top {
  width: 100%;
  height: 50px;
  background-color: #fff;
  border-radius: 3px;
  margin-bottom: 10px;
  box-sizing: border-box;
  padding: 16px 20px;
  color: #606266;
  font-size: 14px;
}

.photo-Particular-top .home-icon-img {
  margin-right: 4px;
}

.photo-Particular-top a {
  color: #606266;
}

.photo-Particular-top a:hover {
  color: #006cff;
}

.photo-Particular-content {
  background-color: #fff;
  box-sizing: border-box;
  padding: 0 20px;
  padding-bottom: 24px;
  position: relative;
}

.photo-Particular-content-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 16px 0;
  border-bottom: 1px dashed #e5e5e5;
}

.photo-Particular-upload-btn {
  width: 130px;
  height: 40px;
  padding: 0;
  border: none;
  background-color: #006cff !important;
  border-radius: 3px;
  color: #fff !important;
  opacity: 1;
  transition: all 0.2s ease;
}

.photo-Particular-upload-btn:hover {
  opacity: 0.9;
}

.type-title {
  font-size: 14px;
  color: #606266;
  padding-left: 12px;
}

.type-select {
  width: 120px;
  height: 36px;
}

.type-select>>>.el-input__inner {
  height: 36px;
}

.el-select-dropdown .el-select-dropdown__list {
  list-style: none;
  padding: 6px !important;
  margin: 0;
  box-sizing: border-box;
}

.el-select-dropdown .el-select-dropdown__item.hover,
.el-select-dropdown .el-select-dropdown__item:hover {
  background-color: #e3e9f8;
  border-radius: 3px;
}

.photo-Particular-del {
  width: 88px;
  height: 36px;
  padding: 0;
  border: 1px solid #d7d7d7;
  border-radius: 3px;
  background-color: rgba(0, 108, 255, 0.01);
  font-size: 14px;
  margin-left: 16px;
}

.material {
  width: 100%;
  border-radius: 3px;
  box-sizing: border-box;
  padding: 15px 14px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

/* 修改 */
.material-item {
  /* max-width: 230px; */
  width: 23.5%;
  margin-bottom: 18px;
  position: relative;
  background-color: #fff;
  box-shadow: 2px 3px 30px 1px rgba(163, 172, 194, 0.5);
  box-sizing: border-box;
  padding: 15px 15px;
  border-radius: 5px;
  transition: all 0.2s linear;
  margin-right: 2%;
}

.material-item:nth-child(4n) {
  margin-right: 0;
}

.material-item:hover {
  background-color: #fff;
  box-shadow: 2px 3px 30px 1px #A3ACC2;
}

.activestyle {
  background-color: #fff;
  box-shadow: 2px 3px 30px 1px rgba(163, 172, 194, 0.5);
}

.material-item-video {
  width: 100%;
  max-height: 121px;
}

.material-item-video video {
  width: 100%;
  height: 121px;
  border-radius: 5px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);

}

.material-item-img {
  width: 100%;
  max-height: 121px;
  display: flex;
  justify-content: center;
}

.material-item-img>img {
  max-width: 100%;
  height: 120px;
  border-radius: 5px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
}

/*  */
.material-item-title {
  line-height: 1;
  margin-top: 15px;
  display: block;
  width: 100%;
  font-size: 14px;
  color: #333;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.material-item-title-time {
  display: block;
  font-size: 12px;
  color: #777;
  margin-top: 6px;
}

.material-item-img-icon {
  position: absolute;
  bottom: 70px;
  left: 20px;
}

video::-webkit-media-controls-timeline {
  display: none;
}

video::-webkit-media-controls-mute-button {
  display: none;
}

video::-webkit-media-controls-toggle-closed-captions-button {
  display: none;
}

video::-webkit-media-controls-volume-slider {
  display: none;
}

.material-group {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
}

.material-checked {
  position: absolute;
  right: 6px;
  top: 6px;
  width: 18px;
  height: 18px;
}

.material-checked>>>.el-checkbox {
  width: 18px;
  height: 18px;
  margin: 0;
}


.material-checked>>>.el-checkbox .el-checkbox__label {
  display: none;
}

.material-checked>>>.el-checkbox__inner {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0);
  /* 修改 */
  border: 2px solid #d9dde5;

}

.material-checked>>>.is-checked .el-checkbox__inner {
  background-color: #006cff;
  border: 2px solid #006cff;
}

.material-checked>>>.el-checkbox__inner::after {
  left: 6px;
  top: 2px;
}

.keyword-return-btn {
  width: 88px;
  height: 40px;
  background-color: #fff;
  border: 1px solid #d9dde5;
  border-radius: 3px;
  color: #565656;
  font-size: 14px;
  opacity: 1;
  transition: all 0.2s linear;
}

.keyword-return-btn:hover {
  opacity: 0.9;
}

.photo-Particular-botton {
  height: calc(100vh - 247px);
}

.switch>>>.el-switch__label.is-active {
  color: #777;
}

.switch>>>.el-switch__label--left {
  margin-right: 0px;
}

.switch-box {
  display: block;
  margin-top: 4px;
  font-size: 12px;
}

.switch-box>>>.el-switch.is-checked .el-switch__core {
  border-color: #006cff;
  background-color: #006cff;
}
</style>